import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaitingToSend = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Artboard" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Artboard",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("circle", {
				id: "Oval",
				stroke: "currentColor",
				strokeWidth: 3,
				fillRule: "nonzero",
				cx: 12,
				cy: 12,
				r: 10.5
			})
		})
	]
});
const ForwardRef = forwardRef(SvgWaitingToSend);
export default ForwardRef;
